import { useState, useEffect } from 'react';

export default function DocsOnThisPage({ headings, scrollRoot }) {
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    if (!headings || headings.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible.length > 0) setActiveId(visible[0].target.id);
      },
      {
        root: scrollRoot?.current ?? null,
        rootMargin: '0px 0px -60% 0px',
        threshold: 0,
      }
    );

    headings.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [headings, scrollRoot]);

  if (!headings || headings.length === 0) return null;

  return (
    <div className="pt-8 pb-12 px-5">
      <p className="text-[10px] font-bold uppercase tracking-widest mb-3 text-gray-400 dark:text-brand-600">
        On this page
      </p>
      <ul className="space-y-1.5">
        {headings.map(({ id, text, level }) => (
          <li key={id}>
            <a
              href={`#${id}`}
              className={`
                block text-[13px] leading-snug transition-colors duration-150
                ${level === 3 ? 'pl-3' : ''}
                ${activeId === id
                  ? 'font-medium text-gray-900 dark:text-brand-200'
                  : 'text-gray-400 hover:text-gray-700 dark:text-brand-600 dark:hover:text-brand-300'
                }
              `}
              onClick={(e) => {
                e.preventDefault();
                document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              {text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
